import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  id: "nav-bar-search-component",
  class: "red-color d-flex align-items-center justify-content-center"
}
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "ps-1 pe-0" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "pe-0 text-small w-25",
      type: "text",
      "aria-label": "Search",
      placeholder: _ctx.placeholderSearch,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textInput) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.clickedSearch && _ctx.clickedSearch(...args)), ["enter"])),
      id: "inputSearch"
    }, null, 40, _hoisted_2), [
      [_vModelText, _ctx.textInput]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "form-select text-small",
        id: "search-select",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTypeSelected) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchOptions, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            key: item.type,
            value: item.type
          }, _toDisplayString(item['text']), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.searchTypeSelected]
      ])
    ]),
    _createElementVNode("button", {
      class: "border-0 text-small p-1 ms-1",
      type: "submit",
      id: "navBarSearchButton",
      disabled: _ctx.buttonDisabled,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickedSearch && _ctx.clickedSearch(...args)))
    }, _toDisplayString(_ctx.buttonSearch), 9, _hoisted_5)
  ]))
}